import request from '@/utils/request'

// Runs one lookup through both providers at once. Read-only: it never changes
// which provider the app is actually using.
// Backend: /api/v2/admin/places-compare (request baseURL already includes /api/v2).

export interface ComparePoi {
  id: string
  name: string
  address: string
  categoryName: string
  distance: number
  phone: string | null
  websiteUri: string | null
  rating: number | null
  userRatingCount: number | null
}

export interface CompareSide {
  count: number
  nearest: number | null
  farthest: number | null
  withPhone: number
  withWebsite: number
  withRating: number
  onlyHere: number
  ms: number
  error: string | null
  pois: ComparePoi[]
}

export interface CompareResult {
  request: {
    latitude: string
    longitude: string
    categoryId: string
    query: string | null
    radius: number
    language: string
  }
  google: CompareSide
  geoapify: CompareSide
  shared: number
  sharedNames: string[]
}

export const comparePlaces = (data: {
  latitude: string
  longitude: string
  categoryId?: string
  query?: string
  radius?: number
  fresh?: boolean
}) => request({ url: '/admin/places-compare', method: 'post', data })
